function logos_scroller(id, mobileOnly_filename_contains) {
  var logoContainer = jQuery(`#${id}`).find(".logo_items");
  // Clear any existing content
  logoContainer.empty();

  var animation_seconds_per_image =
    logoScroller[id].animation_seconds_per_image !== undefined
      ? logoScroller[id].animation_seconds_per_image
      : logoScroller.animation_seconds_per_image;
  var size_in_px =
    logoScroller[id].size_in_px !== undefined
      ? logoScroller[id].size_in_px
      : logoScroller.size_in_px;
  var spacing_in_px =
    logoScroller[id].spacing_in_px !== undefined
      ? logoScroller[id].spacing_in_px
      : logoScroller.spacing_in_px;
  var animation_s =
    animation_seconds_per_image * logoScroller[id].imageUrls.length;

  // Loop through image URLs 2 times for seamless animation
  for (let i = 0; i < 2; i++) {
    jQuery.each(logoScroller[id].imageUrls, function (index, imageUrl) {
      // Extract filename for alt text (remove path and extension)
      const filename = imageUrl
        .split("/")
        .pop()
        .split("?")[0]
        .replace(".jpg", "");
      const altText = filename.replace(/_/g, " ");
      var classes = "";

      // Create img element
      if (imageUrl.indexOf(mobileOnly_filename_contains) > -1 && imageUrl.indexOf(mobileOnly_filename_contains) !== '') {
        classes = "d-block d-md-none";
      }

      const imgElement = jQuery("<img>", {
        src: imageUrl,
        alt: altText,
        class: classes,
        style: `margin: 0 ${spacing_in_px}px; max-width: ${size_in_px}px;`,
      });

      // Append to container
      logoContainer.append(imgElement);
    });
  }

  // Apply animation style
  logoContainer.css({
     "animation-duration": `${animation_s}s`,
     "width": "max-content"
  });

}

// ===== start CONTENTMAP POPULATOR =====

// jQuery function to populate elements with their corresponding HTML
function populateElements(contentMap) {
  jQuery.each(contentMap, function(id, html) {
    const element = jQuery('#' + id);
    if (element.length) {
      element.html(html);
      console.log(`Populated element with ID: ${id}`);
    } else {
    }
  });
}

// Alternative function to populate a single element
function populateElement(id, contentMap) {
  if (contentMap.hasOwnProperty(id)) {
    const element = jQuery('#' + id);
    if (element.length) {
      element.html(contentMap[id]);
      console.log(`Populated element with ID: ${id}`);
      return true;
    } else {
      return false;
    }
  } else {
    console.warn(`No content found for ID '${id}'`);
    return false;
  }
}

// ===== end CONTENTMAP POPULATOR =====

// jQuery function to populate the carousel
function populateCarousel(data,id,custom_classes = 'll_cards_carousel') {
    const parentElement = jQuery('#' + id);
    
    // Create the carousel container
    const carouselContainer = jQuery('<div class="owl-carousel owl-theme '+custom_classes+'"></div>');
    
    // Loop through data and create items
    data.forEach(function(item) {
        // Set defaults
        const onclick = item.onclick || null;
        const title = item.title || null;
        const subtitle = item.subtitle || null;
        const backgroundImage = item.backgroundImage; // Required
        const buttonVisible = onclick ? true : false; // Derived from onclick
      
        // Create main item div
        const itemDiv = jQuery('<div class="rebelsofaging_item"></div>');
        
        // Add onclick if it exists
        if (onclick) {
            itemDiv.attr('onclick', onclick);
        }
        
        // Create card item with background image
        var cardDiv = jQuery('<div class="ll_card_item"></div>').css({
            'background-image': 'url(' + backgroundImage + ')',
        });

       // Set optional background position x
        if (item.backgroundPositionX) {
          cardDiv.css('background-position-x', item.backgroundPositionX);
        }
        
        // Set optional background position y
        if (item.backgroundPositionY) {
          cardDiv.css('background-position-y', item.backgroundPositionY);
        }
        
        // Create flex container
        const flexDiv = jQuery('<div class="d-flex flex-row justify-content-between"></div>');
        
        // Create title element (only if title exists)
        if (title) {
            let titleHtml = title;
            if (subtitle) {
                titleHtml += '<br><small>' + subtitle + '</small>';
            }
            const titleElement = jQuery('<h5 class="hidden">' + titleHtml + '</h5>');
            flexDiv.append(titleElement);
        }
        
        // Create aligner div (only if button is visible)
        if (buttonVisible) {
            const alignerDiv = jQuery('<div class="aligner">`</div>');
            flexDiv.append(alignerDiv);
        }
        
        // Create button
        const buttonClasses = buttonVisible ? 'i_circle plus' : 'i_circle plus hidden';
        const buttonElement = jQuery('<button class="' + buttonClasses + '"></button>');
        flexDiv.append(buttonElement);
        
        // Create vignette div
        const vignetteDiv = jQuery('<div class="d-none vignette">.</div>');
        
        // Assemble the structure
        cardDiv.append(flexDiv);
        cardDiv.append(vignetteDiv);
        itemDiv.append(cardDiv);
        carouselContainer.append(itemDiv);
    });
    
    // Clear parent and append new carousel
    parentElement.empty();
    parentElement.addClass('new_ll carousel-section ll_card_section'); 
    parentElement.append(carouselContainer);
}

// ===== start IMAGE POPULATOR =====

// Helper function to populate a single image element
function _populateImageElement(id, imageData) {
  const element = jQuery('#' + id);
  
  if (!element.length || !element.is('img') || !element.is(":visible")) {
    return false;
  }
  
  // Set required src attribute
  element.attr('src', imageData.src);
  
  // Set optional alt text
  if (imageData.alt) {
    element.attr('alt', imageData.alt);
  }
  
  // Set optional classes
  if (imageData.classes) {
    element.addClass(imageData.classes);
  }
  
  // Handle optional link wrapping
  if (imageData.link) {
    const linkElement = jQuery('<a></a>')
      .attr('href', imageData.link)
      .addClass('image_link');
    
    // Set target="_blank" if newWindow is true
    if (imageData.newWindow) {
      linkElement.attr('target', '_blank');
    }
    
    // Wrap the image with the link
    element.wrap(linkElement);
  }
  
  console.log(`Populated image with ID: ${id}`);
  return true;
}

// jQuery function to populate images with their corresponding data
function populateImages(imageMap) {
  jQuery.each(imageMap, function(id, imageData) {
    _populateImageElement(id, imageData);
  });
}

// Alternative function to populate a single image
function populateImage(id, imageMap) {
  if (!imageMap.hasOwnProperty(id)) {
    console.warn(`No image data found for ID '${id}'`);
    return false;
  }
  
  return _populateImageElement(id, imageMap[id]);
}

// ===== end IMAGE POPULATOR =====

// ===== start BG IMAGE POPULATOR =====

// Helper function to populate a single element's background image
function _populateBackgroundElement(id, backgroundData) {
  const element = jQuery('#' + id);
  
  if (!element.length) {
    return false;
  }
  
  // Set required background-image
  element.css('background-image', `url(${backgroundData.src})`);
  
  // Set optional background position x
  if (backgroundData.positionX) {
    element.css('background-position-x', backgroundData.positionX);
  }
  
  // Set optional background position y
  if (backgroundData.positionY) {
    element.css('background-position-y', backgroundData.positionY);
  }
  
  // Set optional vignette opacity
  if (backgroundData.vignetteOpacity !== undefined) {
    const vignetteElement = element.find('.vignette').first();
    if (vignetteElement.length) {
      // Convert percentage to decimal (e.g., 75 -> 0.75)
      const opacityDecimal = backgroundData.vignetteOpacity / 100;
      vignetteElement.css('opacity', opacityDecimal);
    } else {
    }
  }
  
  // Handle optional link functionality
  if (backgroundData.link) {
    const existingLink = element.find('a').first();
    
    if (existingLink.length) {
      // Populate existing <a> tag
      existingLink.attr('href', backgroundData.link);
      
      // Set target="_blank" if newWindow is true
      if (backgroundData.newWindow) {
        existingLink.attr('target', '_blank');
      } else {
        existingLink.removeAttr('target');
      }
      
      // Add image_link class if it doesn't already exist
      if (!existingLink.hasClass('image_link')) {
        existingLink.addClass('image_link');
      }
    } else {
      // Create new link wrapper if no existing <a> found
      const linkElement = jQuery('<a></a>')
        .attr('href', backgroundData.link)
        .addClass('image_link');
      
      // Set target="_blank" if newWindow is true
      if (backgroundData.newWindow) {
        linkElement.attr('target', '_blank');
      }
      
      // Wrap the element with the link
      element.wrap(linkElement);
    }
  }
  
  console.log(`Populated background image for element with ID: ${id}`);
  return true;
}

// jQuery function to populate background images with their corresponding data
function populateBackgrounds(backgroundMap) {
  jQuery.each(backgroundMap, function(id, backgroundData) {
    _populateBackgroundElement(id, backgroundData);
  });
}

// Alternative function to populate a single background image
function populateBackground(id, backgroundMap) {
  if (!backgroundMap.hasOwnProperty(id)) {
    console.warn(`No background data found for ID '${id}'`);
    return false;
  }
  
  return _populateBackgroundElement(id, backgroundMap[id]);
}

// ===== end BG IMAGE POPULATOR =====

function levive_gallery() {
  if (typeof $.fn.owlCarousel !== 'function') {
      console.warn('OwlCarousel is not loaded');
      return false;
  }
  
  $('.levive_gallery').each(function (index, el) {
    var $el = $(el);
    
    // Wait for images to load before calculating dimensions
    var imagesLoaded = 0;
    var totalImages = $el.find('img').length;
    var imageFlags = []; // Track which images have been counted
    
    if (totalImages === 0) {
      initializeCarousel();
      return;
    }
    
    function checkImagesLoaded(imageIndex) {
      //jQuery('footer').append('<span class="testing_element">ran checkImagesLoaded()</span>')
      // Prevent counting the same image multiple times
      if (imageFlags[imageIndex]) {
        return;
      }
      imageFlags[imageIndex] = true;
      
      imagesLoaded++;
      console.log(`Image ${imageIndex + 1}/${totalImages} loaded`); // Debug log
      
      if (imagesLoaded >= totalImages) {
        calculateDimensions();
        initializeCarousel();
      }
    }

    function calculateDimensions() {
      var containerHeight = $el.height();
      
      if (containerHeight === 0) {
        containerHeight = 300;
      }
      
      $el.find('img').each(function (index, img) {
        var $img = $(img);
        
        function getDefaultAspectRatio() {
          // Try to guess orientation from image source or class
          var src = img.src || '';
          var className = $img.attr('class') || '';
          
          if (src.includes('portrait') || className.includes('portrait') || 
              src.includes('vertical') || className.includes('vertical')) {
            return 0.75; // 3:4 portrait
          } else if (src.includes('square') || className.includes('square')) {
            return 1.0; // 1:1 square
          } else {
            return 0.75; //default
          }
        }
        
        function setDimensions() {
          var w = img.naturalWidth || img.width || $img.width();
          var h = img.naturalHeight || img.height || $img.height();
          var calculatedWidth;
          
          if (w > 0 && h > 0) {
            // Use actual dimensions
            calculatedWidth = Math.round((containerHeight * w) / h);
          } else {
            // Use default aspect ratio
            calculatedWidth = Math.round(containerHeight * getDefaultAspectRatio());
          }
          
          $img.css({
            'width': calculatedWidth + 'px',
            'height': containerHeight + 'px',
            'max-width': 'none',
            'object-fit': 'cover',
            'display': 'block'
          });
        }
        
        // Try immediately
        setDimensions();
        
        // Check if we got valid dimensions
        var w = img.naturalWidth || img.width || $img.width();
        var h = img.naturalHeight || img.height || $img.height();
        
        if (!(w > 0 && h > 0)) {
          // Set timeout fallback - will use default aspect ratio
          var timeout = setTimeout(function() {
            setDimensions(); // This will use the default aspect ratio
          }, 3000); // 3 second timeout
          
          // Wait for image load
          $img.one('load', function() {
            clearTimeout(timeout);
            setDimensions(); // This should now have actual dimensions
          });
          
          // Also listen for error in case image fails to load
          $img.one('error', function() {
            clearTimeout(timeout);
            setDimensions(); // Will use default aspect ratio
          });
        }
      });
    }
    
    function initializeCarousel() {
      // Destroy existing carousel if it exists
      if ($el.hasClass('owl-loaded')) {
        $el.trigger('destroy.owl.carousel').removeClass('owl-loaded owl-drag');
      }
      
      // Initialize OwlCarousel
      $el.owlCarousel({
        autoWidth: true,
        autoplay: true,
        //slideTransition: 'linear',
        autoplaySpeed: 1000,
        autoplayTimeout: 6000,
        //autoplayHoverPause: false, // Disable hover pause for mobile
        center: true,
        loop:false,
        touchDrag: true, // Ensure touch is enabled
        mouseDrag: true,
        responsive: {
          0: {
            mouseDrag: false,
            //touchDrag: true, // Enable touch drag on mobile
            // autoplayHoverPause: false
          },
          768: {
            mouseDrag: true,
            //touchDrag: true,
            // autoplayHoverPause: true
          }
        }
      }).on('drag.owl.carousel', function(event) {
        window.owlWasDragged = true;
        console.log('owlWasDragged = true;');
        $(this).trigger('stop.owl.autoplay');
      }).on('dragged.owl.carousel', function(event) {
        var $this = $(this);
        setTimeout(function() {
          window.owlWasDragged = false;
          console.log('owlWasDragged = false;');
        }, 100);
        setTimeout(function() {
          $this.trigger('play.owl.autoplay', [6000]);
        }, 6000);
      }).on('click.owl.carousel', function(event) {
        window.owlWasDragged = false;
        console.log('owlWasDragged = false;');
      });
      //      Only add mouse events for desktop
      if ($(window).width() > 767) {
        $el.on('mouseenter.gallery', function() {
          console.log('mouseover', $(this));
          $(this).trigger('stop.owl.autoplay');
        }).on('mouseleave.gallery', function() {
          var $element = $(this);
          setTimeout(function() {
            console.log('mouseleave', $element);
            $element.trigger('play.owl.autoplay', [6000]);
          }, 1000);
        });
      }
      if (window.location.href.indexOf('shopifypreview') > -1 || true) {
    $('.levive_gallery .item:not(.place_holder)').on('click', function(e) {
                  e.preventDefault();
                  
                  // Check if this item is in the center/active position
                  var $clickedItem = $(this);
                  var $owlItem = $clickedItem.closest('.owl-item');
                  
                  // Only open lightbox if the clicked item is the center/active one
                  if ($owlItem.hasClass('center')) {
                      // Get the first image in this carousel item
                      var firstImage = $clickedItem.find('img').first();
                      var imageSrc = firstImage.attr('src');
                      var imageAlt = firstImage.attr('alt');
                      
                      // Open Lity lightbox with the first image
                      lity(imageSrc, {
                          alt: imageAlt
                      });
                  } else {
                      // If not center, navigate to this item to make it center
                      var itemIndex = $('levive_gallery .item').index($clickedItem);
                      owl.trigger('to.owl.carousel', [itemIndex]);
                  }
              });
  }
    }
    
    // Load images and wait for them to be ready
    $el.find('img').each(function(imgIndex, img) {
      var $img = $(img);
      
      if (img.complete && img.naturalWidth > 0) {
        // Image already loaded
        checkImagesLoaded(imgIndex);
      } else {
        // Wait for image to load
        $img.on('load.gallery', function() {
          checkImagesLoaded(imgIndex);
        }).on('error.gallery', function() {
          console.warn('Image failed to load:', img.src);
          checkImagesLoaded(imgIndex); // Continue even if image fails
        });
        
        // Fallback timeout in case load event doesn't fire
        setTimeout(function() {
          if (!imageFlags[imgIndex]) {
            console.warn('Image load timeout, proceeding anyway');
            checkImagesLoaded(imgIndex);
          }
        }, 3000);
      }
    });
    //jQuery('footer').append('<span class="testing_element">load_levive_gallery</span>')
  });
}

function auto_height_elements(second_instance = false){
  $window = jQuery(window);

  var totalSplashElementsHeight = 0;

  // Sum up all direct children's outerHeight (including margins)
  jQuery("#levive_splash .page-width > *").each(function () {
    totalSplashElementsHeight += jQuery(this).outerHeight(true);
  });

  // Get .page-width's own paddings
  var $pageWidth = jQuery("#levive_splash .page-width");
  var paddingTop = parseInt($pageWidth.css("padding-top"), 10) || 0;
  var paddingBottom = parseInt($pageWidth.css("padding-bottom"), 10) || 0;

  // Add paddings to totalSplashElementsHeight
  totalSplashElementsHeight += paddingTop + paddingBottom + jQuery('sticky-header').outerHeight(true);

  jQuery("#levive_splash .fullscreen").css({
    "min-height": totalSplashElementsHeight + 40,
    height: $window.height(),
  });
  jQuery(".window_height").css("min-height", $window.height());
  //if ($window.width() <= 767) {
  // jQuery('#levive_splash .page-width').css('height',$window.height() - jQuery('header').outerHeight() - jQuery('#shopify-section-template--21483663327505__6b8b8a38-1485-4267-8a7b-707bf4007ec7').outerHeight())
  // jQuery('.ver_2024 #levive_splash .fullscreen').css('height',jQuery(window).height() + jQuery('#levive_splash .page-width').height() )
  //} else {
  var announcement_bar = jQuery('#banner').outerHeight();
  var to_subtract =
    jQuery(".announcement-bar-section").height() +
    jQuery(".section-header").height() +
    announcement_bar;
  jQuery("#levive_splash .page-width").css({
    "min-height": totalSplashElementsHeight - to_subtract + 40,
    height: $window.height() - to_subtract,
  });
  if (!second_instance) {
    //jQuery('footer').append('<span class="testing_element">second_instance_levive_gallery</span>');
    jQuery('.levive_gallery').css({
      "min-height": (totalSplashElementsHeight - to_subtract + 40) * 1,
        height: ($window.height() - to_subtract) * 0.9,
    });
  }
  if ($window.width() > 767) {
    jQuery(".ll_cards_carousel_wide .ll_card_item").css({
     // "min-height": (totalSplashElementsHeight - to_subtract + 40) * 0.9,
      height: ($window.height() - to_subtract) * 0.9,
    });
  }
}

// ===== start BIG CAROUSEL BUILDER =====

// Function to create a single carousel item
function _createCarouselItem(id, data) {
  // Create the main card item
  const cardItem = jQuery('<div></div>')
    .addClass('ll_card_item ll_card_wide')
    .attr('id', id)
    .css({
      'background-image': `url(${data.backgroundImage})`,
      'background-position-y': data.positionY || 'center'
    });
  
  // Set optional background position x
  if (data.positionX) {
    cardItem.css('background-position-x', data.positionX);
  }
  
  // Create the flex container
  const flexContainer = jQuery('<div></div>')
    .addClass('d-flex flex-column justify-content-between');

  // Create header container
  const headingContainer = jQuery('<div></div>')
    .addClass('align-self-start ll_card_heading_container');
  
  // Create the h2 element
  const h2Element = jQuery('<h3></h3>')
    .html(data.h2Text)
    .addClass('mb-3')
    .css('color', data.h2Color || 'white');

  // Apply text shadow based on color and shadow preference
  if (data.h2Shadow != false) { // Default to true if not specified
    const color = (data.h2Color || 'white').toLowerCase();
    if (color === 'white') {
      h2Element.css('text-shadow', '2px 2px 8px #00000075');
    } else if (color === 'black') {
      h2Element.css('text-shadow', '2px 2px 8px #ffffff75');
    }
  }
  
  // Create the container
  const alignContainer = jQuery('<div></div>')
    .addClass('align-self-start ll_card_a_container');

  data.description_alignmentX = data.description_alignmentX !== undefined ? data.description_alignmentX : 'right';
  
  // Create the description div
  const descriptionDiv = jQuery('<div></div>')
    .addClass('description_bigCarousel')
    .addClass('text-' + data.description_alignmentX)

  // Create the description content
  const description_content = jQuery('<span></span>')
    .addClass('description_content d-inline-block')
    .css('width', data.description_width || '80%') 
    .text(data.description || '')
    .css('color', data.description_color || 'white');
  
  // Create the button/link
  the_button_alignment = data.button_alignment !== undefined ? data.button_alignment : 'end';
  the_button_alignment = data.description_alignmentX == 'left' ? 'start' : the_button_alignment;
  the_button_alignment = data.button_alignment !== undefined ? data.button_alignment : the_button_alignment;
  const buttonLink = jQuery('<a></a>')
    .addClass('ll_copper_bg ll_button ll_button_small image_link')
    .addClass('float-' + the_button_alignment)
    .attr('href', data.link || '#')
    .attr('onclick','event.stopPropagation()')
    .text(data.buttonText || 'Show gallery');
  
  // Set target="_blank" if newWindow is true
  if (data.newWindow) {
    buttonLink.attr('target', '_blank');
  }
  
  // Create the vignette
  const vignette = jQuery('<div></div>')
    .addClass('vignette')
    .text('.');
  
  // Set vignette opacity if specified
  if (data.vignetteOpacity !== undefined) {
    const opacityDecimal = data.vignetteOpacity / 100;
    vignette.css('opacity', opacityDecimal);
  }
  
  // Assemble the structure
  if (data.description_alignmentY == 'top') {
    alignContainer.append(buttonLink);
    headingContainer.append(h2Element).append(descriptionDiv);
  } else {
    alignContainer.append(descriptionDiv).append(buttonLink);
    headingContainer.append(h2Element);
  }
  descriptionDiv.append(description_content);
  flexContainer.append(headingContainer).append(alignContainer);
  cardItem.append(flexContainer).append(vignette);
  
  return cardItem;
}

// Function to build the complete carousel structure
function buildBigCarousel(carouselId, bigCarouselMap) {
  const targetElement = jQuery('#' + carouselId);
  
  if (!targetElement.length) {
    return false;
  }
  
  if (!bigCarouselMap.hasOwnProperty(carouselId)) {
    console.warn(`No carousel data found for ID '${carouselId}'`);
    return false;
  }
  
  // Clear existing content
  targetElement.empty();
  
  // Add the carousel classes to the target element
  targetElement.addClass('new_ll carousel-section ll_card_section');
  
  // Create the owl-carousel container
  const owlContainer = jQuery('<div></div>')
    .addClass('owl-carousel owl-theme ll_cards_carousel_wide');
  
  // Create all carousel items
  const carouselData = bigCarouselMap[carouselId];
  jQuery.each(carouselData, function(itemId, itemData) {
    const carouselItem = _createCarouselItem(itemId, itemData);
    owlContainer.append(carouselItem);
  });
  
  // Append the owl container to the target element
  targetElement.append(owlContainer);
  
  console.log(`Built carousel for: ${carouselId}`);
  return true;
}

// Function to build all carousels found in the DOM
function buildAllBigCarousels(bigCarouselMap) {
  jQuery.each(bigCarouselMap, function(carouselId, carouselData) {
    buildBigCarousel(carouselId, bigCarouselMap);
  });
}

// Function to update a single carousel item after it's been built
function updateCarouselItem(carouselId, itemId, newData, bigCarouselMap) {
  // Update the data in the map
  if (bigCarouselMap[carouselId] && bigCarouselMap[carouselId][itemId]) {
    jQuery.extend(bigCarouselMap[carouselId][itemId], newData);
    
    // Find the existing item and replace it
    const existingItem = jQuery('#' + itemId);
    if (existingItem.length) {
      const newItem = _createCarouselItem(itemId, bigCarouselMap[carouselId][itemId]);
      existingItem.replaceWith(newItem);
      console.log(`Updated carousel item: ${itemId}`);
      return true;
    }
  }
  
  console.warn(`Could not update carousel item: ${itemId}`);
  return false;
}

// ===== end BIG CAROUSEL BUILDER =====

// ===== start RISA CAROUSEL BUILDER =====

// Function to create a single risa carousel item
function _createRisaCarouselItem(id, data) {
  // Create the main card item
  const cardItem = jQuery('<div></div>')
    .addClass('risa_new_card_item')
    .attr('id', id);
  
  // Create the top part with background image
  const topPart = jQuery('<div></div>')
    .addClass('d-flex flex-column h3 justify-content-center p-4 risa_new_card_top_part position-relative')
    .css({
      'background-image': `url(${data.backgroundImage})`,
      'background-position-y': data.positionY || 'center'
    });
  
  // Set optional background position x
  if (data.positionX) {
    topPart.css('background-position-x', data.positionX);
  }
  
  // Create the title text
  const titleText = jQuery('<div></div>')
    .addClass('risa_new_card_top_part_text')
    .html(data.titleText);
  
  // Create the vignette
  const vignette = jQuery('<div></div>')
    .addClass('vignette')
    .text('.');
  
  // Set vignette opacity if specified
  if (data.vignetteOpacity !== undefined) {
    const opacityDecimal = data.vignetteOpacity / 100;
    vignette.css('opacity', opacityDecimal);
  }
  
  // Create the bottom part with description
  const bottomPart = jQuery('<div></div>')
    .addClass('body_text ll_copper_bg p p-4 risa_new_card_bottom_part rounded-bottom-5')
    .html(data.description);
  
  // Assemble the structure
  topPart.append(titleText).append(vignette);
  cardItem.append(topPart).append(bottomPart);
  
  return cardItem;
}

// Function to build the complete risa carousel structure
function buildRisaCarousel(carouselId, splitCardCarouselMap) {
  const targetElement = jQuery('#' + carouselId);
  
  if (!targetElement.length) {
    return false;
  }
  
  if (!splitCardCarouselMap.hasOwnProperty(carouselId)) {
    console.warn(`No carousel data found for ID '${carouselId}'`);
    return false;
  }
  
  // Clear existing content
  targetElement.empty();
  
  // Add the carousel classes to the target element
  targetElement.addClass('page-width new_ll carousel-section ll_card_section');
  
  // Create the owl-carousel container
  const owlContainer = jQuery('<div></div>')
    .addClass('owl-carousel owl-theme ll_cards_carousel_4_max');
  
  // Create all carousel items
  const carouselData = splitCardCarouselMap[carouselId];
  jQuery.each(carouselData, function(index, itemData) {
    const itemId = `${carouselId}_item_${index}`;
    const carouselItem = _createRisaCarouselItem(itemId, itemData);
    owlContainer.append(carouselItem);
  });
  
  // Append the owl container to the target element
  targetElement.append(owlContainer);
  
  console.log(`Built risa carousel for: ${carouselId}`);
  return true;
}

// Function to build all risa carousels found in the DOM
function buildAllRisaCarousels(splitCardCarouselMap) {
  jQuery.each(splitCardCarouselMap, function(carouselId, carouselData) {
    buildRisaCarousel(carouselId, splitCardCarouselMap);
  });
}

// Function to update a single risa carousel item after it's been built
function updateRisaCarouselItem(carouselId, itemIndex, newData, splitCardCarouselMap) {
  // Update the data in the map
  if (splitCardCarouselMap[carouselId] && splitCardCarouselMap[carouselId][itemIndex]) {
    jQuery.extend(splitCardCarouselMap[carouselId][itemIndex], newData);
    
    // Find the existing item and replace it
    const itemId = `${carouselId}_item_${itemIndex}`;
    const existingItem = jQuery('#' + itemId);
    if (existingItem.length) {
      const newItem = _createRisaCarouselItem(itemId, splitCardCarouselMap[carouselId][itemIndex]);
      existingItem.replaceWith(newItem);
      console.log(`Updated risa carousel item: ${itemId}`);
      return true;
    }
  }
  
  console.warn(`Could not update risa carousel item at index: ${itemIndex}`);
  return false;
}

// To use:
// buildRisaCarousel('risa_carousel', splitCardCarouselMap);
// or
// buildAllRisaCarousels(splitCardCarouselMap);

// ===== end RISA CAROUSEL BUILDER =====

// ===== start VALUE ICONS BUILDER =====

// Function to create a single value icon item
function createValueIconItem(iconData) {
    return $('<div>')
        .addClass('value_icon_with_caption flex-even d-flex flex-column')
        .append(
            $('<img>')
                .addClass('margin-auto-center')
                .attr('src', iconData.icon)
        )
        .append(
            $('<div>').html(iconData.caption)
        );
}

// Main function to build the complete value icons section
function buildValueIconsSection(contentMap) {
    // Create desktop version container
    const desktopContainer = $('<div>')
        .addClass('h-scroll d-flex justify-content-evenly align-items-center d-none d-lg-flex text-center');
    
    // Add items to desktop container
    contentMap.forEach(item => {
        desktopContainer.append(createValueIconItem(item));
    });
    
    // Create mobile version container
    const mobileOuterContainer = $('<div>')
        .addClass('h-scroll logos d-block d-lg-none');
    
    const mobileInnerContainer = $('<div>')
        .addClass('logo_items h-scroll justify-content-evenly align-items-center d-flex d-lg-none text-center');
    
    // Add items to mobile container (duplicated for scrolling effect)
    contentMap.forEach(item => {
        mobileInnerContainer.append(createValueIconItem(item));
    });
    // Duplicate items for seamless scrolling
    contentMap.forEach(item => {
        mobileInnerContainer.append(createValueIconItem(item));
    });
    
    mobileOuterContainer.append(mobileInnerContainer);
    
    // Create main wrapper and append both versions
    const mainWrapper = $('<div>');
    mainWrapper.append(desktopContainer);
    mainWrapper.append(mobileOuterContainer);
    
    return mainWrapper;
}

// Function to build a single icon section by targeting its ID
function buildIconSection(sectionId, iconSectionsContent) {
    const targetElement = $('#' + sectionId);
    
    if (!targetElement.length) {
        return false;
    }
    
    if (!iconSectionsContent.hasOwnProperty(sectionId)) {
        console.warn(`No icon section data found for ID '${sectionId}'`);
        return false;
    }
    
    // Clear existing content
    targetElement.empty();
    
    // Build the section and append to target
    const iconSection = buildValueIconsSection(iconSectionsContent[sectionId]);
    targetElement.append(iconSection);
    
    console.log(`Built icon section for: ${sectionId}`);
    return true;
}

// Function to build all icon sections found in the DOM
function buildAllIconSections(iconSectionsContent) {
    $.each(iconSectionsContent, function(sectionId, sectionData) {
        buildIconSection(sectionId, iconSectionsContent);
    });
}

// ===== end VALUE ICONS BUILDER =====